import React, { useState } from "react";
import { Link, useNavigate, } from "react-router-dom";
import { svgs } from "../common/assats";
import "./../styles/homePage/menu.scss";
import { useTranslation } from "react-i18next";
import { useUser } from "../common/contexts/UserContext";
import { Role } from "../common/types/roles";
import { handleLogout } from "../common/api/restServices";
import UserInfoContainer from "./UserInfoContainer";

const userMenuAccess: Record<Role, { path: string; labelKey: string; icon: React.ElementType }[]> = {
  Admin: [
    { path: "/Home/Dashboard", labelKey: "menu.dashboard", icon: svgs.menu.Dashboard },
    { path: "/Home/Users", labelKey: "menu.users", icon: svgs.menu.User },
    { path: "/Home/Patients", labelKey: "menu.patientsList", icon: svgs.menu.UserAdd },
    { path: "/Home/Devices", labelKey: "menu.devices", icon: svgs.menu.Devices },
    { path: "/Home/Sites", labelKey: "menu.sites", icon: svgs.menu.Sites },
    { path: "/Home/Fota", labelKey: "menu.fota", icon: svgs.menu.Fota },
    { path: "", labelKey: "menu.logout", icon: svgs.menu.Logout }
  ],
  HCP: [
    { path: "/Home/Dashboard", labelKey: "menu.dashboard", icon: svgs.menu.Dashboard },
    //{ path: "/Home/Users", labelKey: "menu.users", icon: svgs.menu.User },
    { path: "/Home/Patients", labelKey: "menu.patientsList", icon: svgs.menu.UserAdd },
    //{ path: "/Home/Devices", labelKey: "menu.devices", icon: svgs.menu.Devices },
    // { path: "/Home/Sites", labelKey: "menu.sites", icon: svgs.menu.Sites },
    // { path: "/Home/Fota", labelKey: "menu.fota", icon: svgs.menu.Fota },
    { path: "", labelKey: "menu.logout", icon: svgs.menu.Logout }
  ]
};

const MenuSideBar = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const { user, setUser } = useUser();
  const [mounted, setMounted] = useState(false);

  const hasAccess = (component: string): boolean => {
    if (!user?.role) return false;
    return (
      userMenuAccess[user.role]?.some((item) =>
        item.path.includes(component)
      ) ?? false
    );
  };
  
  function logout() {
    handleLogout();
  }

  function isHighlighted(path: string) {
    return window.location.href.includes(path);
  }

  return (
    <div className={`menu-side-bar-main-container full`}>
      <div className='menu-headline'>
        <svgs.logos.Logo className='logo' />
      </div>

      {user && (
        <UserInfoContainer
          user={user}
          onNavigate={(path, state) => navigate(path, state)}
        />
      )}

      {user?.role &&
        userMenuAccess[user.role].map(
          ({ path, labelKey, icon: Icon }, index) => (
            <React.Fragment key={labelKey}>
              {" "}
              {/* Use Fragment to avoid additional div */}
              {labelKey.includes("logout") && (
                <div className={`link-style`}></div>
              )}
              <Link
                className="link-style"
                to={path}
                onClick={labelKey === "menu.logout" ? logout : undefined}
              >
                <div className={`place-holder ${!path ? "" : isHighlighted(path) ? "highlighted" : ""}`}></div>
                <div className={`text-and-icon ${!path ? "" : isHighlighted(path) ? "highlighted" : ""}`}>
                  <Icon className='icon' />
                  <span className="item ">{t(labelKey)}</span>
                </div>
              </Link>
            </React.Fragment>
          ))}
    </div>
  );
};

export default MenuSideBar;
